export default function(x) {
  return function() {
    return x;
  };
}



// WEBPACK FOOTER //
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/d3-force/src/constant.js